import React from "react";

import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const ModalLogout = (props) => (
  <Modal isOpen={props.show}>
    <ModalHeader>Atenção!</ModalHeader>
    <ModalBody>
      <p>Tem certeza que deseja sair?</p>
    </ModalBody>
    <ModalFooter>
      <button className="btn btn-primary" onClick={props.onConfirm}>
        Confirmar
      </button>
      <button className="btn btn-danger" onClick={props.onCancel}>
        Cancelar
      </button>
    </ModalFooter>
  </Modal>
);

export default ModalLogout;



// WEBPACK FOOTER //
// ./src/components/Admin/Modal/ModalLogout.js